/**
 * Fix in CE21 (#635, 29 Oct 2026): the people Tim flagged from a state list's review, for him to correct in CE21 by
 * hand (a licence number the state does not list, or one also on another person). Keystone writes nothing to CE21.
 * Reached from the Licences line and ⌘K; a flag goes once a later list no longer finds the problem.
 */
import type { PersonLine, ViewDef } from "../views";

export const CE21_FIXES: ViewDef = {
  id: "ce21-fixes",
  title: "Fix in CE21",
  paged: false,
  emails: "rows",
  columns: [
    { key: "standing", label: "Standing", kind: "standing" },
    { key: "licence", label: "Licence" },
    { key: "why", label: "Why", wide: true },
    { key: "flagged", label: "Flagged", kind: "date" },
  ],
  empty: "Nothing flagged to fix in CE21.",
  facts: (rows: PersonLine[]) => [[rows.filter((r) => r.tag === "not_on_list").length, "not on the state list"]],
};
